import Search from "@material-ui/icons/Search";
import React, { useState } from 'react';
import styled from 'styled-components';

export default function SearchLogs(props) {

  const { onSearch } = props;
  const [search, setSearch] = useState(null)

  return (
    <Container>
      <SearchInput placeholder="Pesquisar" value={search} onChange={event => setSearch(event.target.value)} />
      <SearchButton onClick={() => onSearch(search)}><Search /></SearchButton>
    </Container>
  );
}

const SearchButton = styled.button`
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 3px;
  color: #000;
  cursor: pointer;
  height: 40px;
  margin-left: 5px;
  padding: 0 10px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const SearchInput = styled.input`
  width: 100%;
  height: 40px;
  border-radius: 5px;
  border: 1px solid #ccc;
  padding: 0 10px;
`

const Container = styled.div`
  width: 35%;
  display: flex;
  flex-direction: row;
  align-items: center;
`;